/**
 * Tek kaynaklı site sabitleri.
 *
 * Domain değiştiğinde yalnızca `SITE_URL` güncellenir; robots.txt, sitemap.xml,
 * manifest.json ve çalışma zamanı meta etiketleri buradan türetilir.
 * (Statik `src/app.html` içindeki crawler varsayılanları da aynı URL'i kullanır;
 * ileride bu değerler build sırasında bu dosyadan üretilebilir.)
 */
export const SITE_URL = 'https://repcheck.libedge.com';

export const SITE = {
	url: SITE_URL,
	name: 'RepCheck',
	tagline: 'Free manuscript reporting audit',
	themeColor: '#1c1917',
	backgroundColor: '#faf8f4',
	locale: {
		en: 'en_US',
		tr: 'tr_TR'
	}
} as const;

/** Site köküne göre mutlak URL üretir. */
export function absoluteUrl(path = '/'): string {
	if (/^https?:\/\//i.test(path)) return path;
	return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}
